import { ChangeRoute } from '@casino/core/lib/components';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { GAME_CATEGORY_FILTER, USER_FIELDS } from 'core/constants';
import { withUser, withModalActions } from 'core/hocs';
import { HeadHelmet } from 'components/head-helmet/head-helmet';
import { Main } from 'components/main/main';
import { MainBanner } from 'components/main-banner/main-banner';
import { GamesFilters } from 'components/games-filters/games-filters';

import { MODAL_IDS, PAGE_NAMES } from '../../constants';

class Games extends Component {
  constructor(props) {
    super(props);
    const {
      isUserLoggedIn,
      isUserRegistered,
      openModalAndCloseOthers,
      match: {
        params: {
          category,
        },
      },
    } = this.props;

    const isFavoriteCategory = category === GAME_CATEGORY_FILTER.FAVORITE;

    if (isFavoriteCategory && !isUserLoggedIn) {
      openModalAndCloseOthers(isUserRegistered ? MODAL_IDS.SIGN_IN : MODAL_IDS.SIGN_UP);
    }
  }

  render() {
    const {
      isUserLoggedIn,
      match: {
        params: {
          category,
        },
      },
    } = this.props;

    const isFavoriteCategory = category === GAME_CATEGORY_FILTER.FAVORITE;
    const isLiveGamesCategory = category === GAME_CATEGORY_FILTER.LIVE_CASINO;

    if (isFavoriteCategory && !isUserLoggedIn) {
      return <ChangeRoute to="/" />;
    }

    return (
      <>
        <HeadHelmet
          page={PAGE_NAMES.GAMES}
          values={{ category }}
          options={{ indexing: !isFavoriteCategory }}
        />

        <MainBanner
          className={classNames('games-page-banner', {
            'logged-in': isUserLoggedIn,
            'not-logged-in': !isUserLoggedIn,
          })}
          isLiveGamesCategory={isLiveGamesCategory}
        />

        <Main className="is-games-page position-relative">
          <GamesFilters />
        </Main>
      </>
    );
  }
}

Games.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  isUserRegistered: PropTypes.bool.isRequired,
  openModalAndCloseOthers: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
};

export default withModalActions(
  withUser(Games, [
    USER_FIELDS.IS_USER_LOGGED_IN,
    USER_FIELDS.IS_USER_REGISTERED,
  ])
);
